import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 40px 0;
`;

const PageHeader = styled.h1`
  font-size: 2rem;
  margin-bottom: 30px;
  position: sticky;
  top: 180px;
  background-color: #000;
  z-index: 100;
  padding: 15px 0;
  margin-top: -15px;

  @media (max-width: 768px) {
    top: 140px;
  }
`;

const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const ComingSoonMessage = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  
  h2 {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }
  
  p {
    color: #aaa;
    line-height: 1.6;
    max-width: 600px;
    margin: 0 auto;
  }
`;

function GuestArtists() {
  return (
    <PageContainer>
      <PageHeader>Guest Artists</PageHeader>
      
      <PageContent>
        <ComingSoonMessage>
          <h2>Coming Soon</h2>
          <p>
            We're excited to announce our upcoming Guest Artists program, where we'll showcase 
            talented artists from around the world. Check back soon for featured artists, 
            exclusive interviews, and special collaborations.
          </p>
        </ComingSoonMessage>
      </PageContent>
    </PageContainer>
  );
}

export default GuestArtists;